import { Component, OnInit,OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, NavigationEnd }  from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
import { Subscription } from 'rxjs';
//import { Categorias, ICategorias } from '../../../../models/categorias.model';
import { DataModelComponent } from '../../../../models/data.model.component';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';
import { DataModel,IDataModel } from '../../../../models/data.model';

export interface IAnexoItem extends IDataModel {
  nome:string,
  info:string,
  arquivo:string,
}
export class Anexos extends DataModel<IAnexoItem>
{
  constructor( private db:AngularFirestore){
      super(db,'anexos');
  }
} 

@Component({
  selector: 'anexos',
  templateUrl: './anexos.component.html',
  styleUrls: ['./anexos.component.scss']
})

export class AnexosComponent  extends DataModelComponent<IAnexoItem> implements OnInit,OnDestroy {
  subPath:string='anexos/'
  pageIndex:number=0;
  oldPageIndex:number=0;
  dataSource: Array<any> = [];
  dataClass: Anexos;
  dataEvent: Subscription;
  @ViewChild('grid') grid: MatDataGridComponent;
  colunas = [{field:"nome",text:"Nome"},
             {field:"info",text:"Informações"},
            {field:"arquivo",text:"Arquivo"}];

  constructor(private db: AngularFirestore, private router:Router) {
    super( {
       nome: new FormControl(),
       info: new FormControl(),
       arquivo: new FormControl(),
       inativo: new FormControl(),
    });
    this.dataClass = new Anexos(db);
  }

  ngOnInit() {
    this.dataEvent = this.dataClass.changedEvent.subscribe(
      d => {
        this.dataSource = d.sort(function(a:any,b:any) {return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0);} );
      });
      this.dataClass.verInativo=false;  
  }

  ngOnDestroy(){
    this.dataEvent.unsubscribe();
  }

  doPostItem(event){
    this.dataClass.post(this.item);
    super.doPostItem(event);
    this.pageIndex = this.oldPageIndex;
  }
  doEditItem(x){
    this.oldPageIndex = this.grid.pageIndex;
    super.doEditItem(x);
  }
  doCancelItem(){
    super.doCancelItem();
    this.pageIndex = this.oldPageIndex;
  }

  getFilterAttrib(){
    return 'ver inativos';
  }

  doCheckFilter(x:boolean){
    this.dataClass.verInativo = this.grid.checkFilterValue;
  }

  doItemClick(item:any){
    this.router.navigate(['/subCategorias/'+item.codigo]);
  }


}
